import { Chart } from '@frontend/chart/types';

export const IOTS_VOLUME_BY_TYPE_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'android', data: [{ label: 'full_period', value: 28 }] },
        { name: 'access_controller', data: [{ label: 'full_period', value: 12 }] },
        { name: 'payment_terminal', data: [{ label: 'full_period', value: 6 }] },
        { name: 'printer', data: [{ label: 'full_period', value: 4 }] },
        { name: 'server', data: [{ label: 'full_period', value: 2 }] },
        { name: 'mobile', data: [{ label: 'full_period', value: 1 }] }
    ]
};
